export default {
    title: 'Session Results',

    sessionInfo: {
        title: 'Basic Information',
        items: {
            date: 'Session Date',
            duration: 'Duration',
            studentCount: 'Participants',
        },
        durationFormat: '{startTime} ~ {endTime} ({duration} min)',
    },
    curriculumInfo: {
        title: 'Session Name',
    },

    summary: {
        title: 'Activity Information',
        completedActivity: 'Completed Activities',
        headers: {
            activity: 'Activity',
            achievement: 'Achievement',
        },
    },

    studentResults: {
        title: 'Correct Answers and MVP per Student',
        mvp: 'MVP',
        headers: {
            student: 'Student',
            answers: 'Correct Answers',
            score: 'Score',
        },
    },

    actions: {
        close: 'Close Window',
        print: 'Print',
        export: 'Export',
    },

    errors: {
        windowClose: 'An error has occurred. Please close the window manually.',
    },
};
